// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"740":"24e33615","825":"2ff881fa"}[chunkId] + ".chunk.js";
};